export const hasWindow = () => {
    return typeof window !== "undefined";
};

export const canUseDOM = () => {
    return hasWindow() && !!window.document?.createElement;
};
